/**
 * @fileoverview Slice Redux para gerenciamento do modal UserManager.
 * Controla estado de abertura/fechamento do modal de gerenciamento de usuários.
 * Implementa padrão Redux Toolkit com createSlice.
 * 
 * @module UserManagerSlice
 * @requires @reduxjs/toolkit
 * @since 1.0.0
 * @version 2.0.0
 *
 * @see {@link ../../components/User/UserManager.jsx} - Componente que usa este slice
 * @see {@link ../store.js} - Store Redux que integra este reducer
 */

import { createSlice } from '@reduxjs/toolkit';

const userManagerSlice = createSlice({
  name: 'userManager',
  initialState: {
    isOpen: false,
  },
  reducers: {
    /**
     * Abre o modal de gerenciamento de usuários.
     * @function openUserManager
     * @param {Object} state - Estado atual do slice
     * @returns {void}
     */
    openUserManager: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de gerenciamento de usuários.
     * @function closeUserManager
     * @param {Object} state - Estado atual do slice
     * @returns {void}
     */
    closeUserManager: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openUserManager, closeUserManager } = userManagerSlice.actions;
export default userManagerSlice.reducer;
